import moment from 'moment-jalaali';

// Shared period presets for the date-range filter bar (used by آمار سامانه and
// حسابداری آموزشگاه). Keeping a single source avoids the two screens drifting
// apart on Persian week/quarter/year boundaries.
export const PRESET_OPTIONS = [
    { value: 'today', label: 'امروز' },
    { value: 'this_week', label: 'این هفته' },
    { value: 'this_month', label: 'این ماه' },
    { value: 'this_quarter', label: 'این فصل' },
    { value: 'this_year', label: 'امسال' },
];

// Map a preset key to a { start, end } pair of JS Dates (Jalali-aware boundaries).
export const calculateDatesFromPreset = (presetValue) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let start = null;
    let end = new Date(today);

    switch (presetValue) {
        case 'today':
            start = new Date(today);
            end = new Date(today);
            break;
        case 'this_week': {
            // Saturday is the first day of the Persian week.
            // JavaScript getDay(): 0=Sunday, 1=Monday, ..., 6=Saturday
            const weekday = today.getDay();
            const daysSinceSaturday = weekday === 6 ? 0 : (weekday + 1) % 7;
            start = new Date(today);
            start.setDate(today.getDate() - daysSinceSaturday);
            break;
        }
        case 'this_month': {
            // First day of the current Persian month.
            const todayJalali = moment(today);
            const firstDayOfMonth = moment(todayJalali.format('jYYYY/jMM/01'), 'jYYYY/jMM/jDD');
            start = firstDayOfMonth.toDate();
            break;
        }
        case 'this_quarter': {
            // First day of the current Persian quarter.
            // Persian quarters: Spring (1-3), Summer (4-6), Fall (7-9), Winter (10-12)
            const todayJalaliQuarter = moment(today);
            const jalaliMonth = todayJalaliQuarter.jMonth() + 1; // jMonth() is 0-11
            const jalaliYear = todayJalaliQuarter.jYear();
            let quarterStartMonth;
            if (jalaliMonth >= 1 && jalaliMonth <= 3) {
                quarterStartMonth = 1; // بهار
            } else if (jalaliMonth >= 4 && jalaliMonth <= 6) {
                quarterStartMonth = 4; // تابستان
            } else if (jalaliMonth >= 7 && jalaliMonth <= 9) {
                quarterStartMonth = 7; // پاییز
            } else {
                quarterStartMonth = 10; // زمستان
            }
            const firstDayOfQuarter = moment(`${jalaliYear}/${quarterStartMonth}/01`, 'jYYYY/jMM/jDD');
            start = firstDayOfQuarter.toDate();
            break;
        }
        case 'this_year': {
            // First day of the current Persian year (1/1).
            const todayJalaliYear = moment(today);
            const firstDayOfYear = moment(`${todayJalaliYear.jYear()}/01/01`, 'jYYYY/jMM/jDD');
            start = firstDayOfYear.toDate();
            break;
        }
        default:
            return { start: null, end: null };
    }

    return { start, end };
};

// Format a JS Date as a local YYYY-MM-DD string (no UTC shift), suitable for
// sending to the backend date filters.
export const toApiDateString = (date) => {
    if (!date) return undefined;
    if (!(date instanceof Date)) return date;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
